import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {setContextualHelp} from "actions/index.js";
import {PARAMETERIZER_FACTOR} from 'constants/contextual-help.js';
import {PARAMETERIZER_OFFSET} from 'constants/contextual-help.js';
import {PARAMETERIZER_DROPDOWN} from 'constants/contextual-help.js';
import {PROBABILITY} from 'constants/contextual-help.js';
import { connect } from "react-redux";

class HarmonyEffectComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    getParameterOptions() {
        let parameters = this.props.effect
            .getAvailableParameters();

        return parameters.map(
            p => ({
                label: p.name,
                value: p}));
    }

    getParameterOption(o) {
        if (o === undefined) {
            return undefined;
        }
        let filtered = this.getParameterOptions().filter(
            x => x.value === o);

        return filtered.length > 0 ? filtered[0] : undefined;
    }

    handleParameterChange(p) {
        this.props.effect.parameter = p.value;
        this.setState(this.state);
    }

    setContextualHelp(e, contextualHelp) {
        e.stopPropagation();
        this.props.setContextualHelp(contextualHelp);
    }

    render() {
        return (
            <div>
              <ConditionedComponent condition={this.isEnabled()}>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  contextualHelp={PARAMETERIZER_FACTOR}
                  name={'Pitch'}
                  parameter={this.props.effect.pitchParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.1}
                  min={-32}
                  max={32}/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  contextualHelp={PARAMETERIZER_FACTOR}
                  name={'Velocity'}
                  parameter={this.props.effect.velocityParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.01}
                  min={0}
                  max={1}/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  contextualHelp={PARAMETERIZER_FACTOR}
                  name={'Timing Offset'}
                  parameter={this.props.effect.timingOffsetParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={0.01}
                  min={0}
                  max={4}/>
               <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Probability'}
                  contextualHelp={PROBABILITY}
                  parameter={this.props.effect.probabilityParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={0}
                  max={100}/>
              </ConditionedComponent>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(null, mapDispatchToProps)(HarmonyEffectComponent);
